module.exports = __webpack_public_path__ + "assets/baichui.3c3f2a28.svg";